module.exports = __webpack_public_path__ + "img/logo.729a6ed0.png";